import * as React from "react";
import Box from "@mui/material/Box";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import moment from "moment";

function ActregGuestDetails(props) {
  const useStyles = makeStyles((theme) => ({
    root: {
      minWidth: 1000,
      display: "inline-block",
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: "33.33%",
      flexShrink: 0,
      fontWeight: 600,
    },
    secondaryHeading: {
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.text.secondary,
    },
  }));
  const classes = useStyles();
  //
  return (
    <Grid container spacing={2} >
      <Grid item lg={6} xs={12}>
        <Card>
          <CardContent>
            <Typography className={classes.headig} align="center" size="25px">
              <strong>Guest Details</strong>
            </Typography>
            <TableRow>
              <TableCell align="left">
                <strong>Guest Id</strong>
              </TableCell>
              <TableCell align="left">{props.guestdetails.id}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell align="left">
                <strong>CheckIn Date</strong>
              </TableCell>
              <TableCell align="left">
              {moment(props.guestdetails.checkInDate).format('DD-MM-YYYY')}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell align="left">
                <strong>Email</strong>
              </TableCell>
              <TableCell align="left">{props.guestdetails.email}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell align="left">
                <strong>DueAmount</strong>
              </TableCell>
              <TableCell align="left">{props.guestdetails.dueAmount.toFixed(0)}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell align="left">
                <strong>Name</strong>
              </TableCell>
              <TableCell align="left">{props.guestdetails.firstName}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell align="left">
                <strong>Bed Id</strong>
              </TableCell>
              <TableCell align="left">{props.guestdetails.bedId}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell align="left">
                <strong>Last dueDate</strong>
              </TableCell>
              <TableCell align="left">
              {moment(props.guestdetails.lastBillGenerationDate).format('DD-MM-YYYY')}
                </TableCell>
            </TableRow>
          </CardContent>
        </Card>
        
      </Grid>
      <Grid item lg={6} xs={12}>
        
        <Card>
          <CardContent>
          <Typography className={classes.headig} align="center" size="25px"><strong>Occupancy Details</strong></Typography>
            <TableRow>
              <TableCell align="left">
                <strong>Occupancy Type</strong>
              </TableCell>
              <TableCell align="left">
                {props.guestdetails.occupancyType}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell align="left">
                <strong>Guest Status</strong>
              </TableCell>
              <TableCell align="left">
                {props.guestdetails.guestStatus}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell align="left">
                <strong>Default Rent</strong>
              </TableCell>
              <TableCell align="left">
                {props.guestdetails.defaultRent.toFixed()}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell align="left">
                <strong>Total AmountPaid</strong>
              </TableCell>
              <TableCell align="left">{props.TotalAmountByGuest}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell align="left">
                <strong>Security Amount</strong>
              </TableCell>
              <TableCell align="left">
                {props.guestdetails.securityDeposit.toFixed()}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell align="left">
                <strong>Due Date</strong>
              </TableCell>
              <TableCell align="left">
              {moment(props.guestdetails.billGeneratedTill).format('DD-MM-YYYY')}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell align="left">
                <strong>Personel Number</strong>
              </TableCell>
              <TableCell align="left">
                {props.guestdetails.personalNumber}
              </TableCell>
            </TableRow>
          </CardContent>
        </Card> 

      </Grid>
    </Grid>
   
  );
}
export default ActregGuestDetails;
